<template>
  <el-scrollbar style="width:100%;height: 100%;overflow:auto;">
    <el-form label-width="130px" style="margin-top: 10px">
      <el-row>
        <el-col :span="13">
          <el-form-item label="年度月份：" required>
            <el-select v-model="year" placeholder="年度" style="width:30%;padding-right:5px; " @change="getEmployeeKpiList">
              <el-option v-for="year in yearList" :key="year.value" :label="year.label" :value="year.value"></el-option>
            </el-select>
            <el-select v-model="month" placeholder="月份" style="width:70%;padding-left: 5px" multiple>
              <el-option key="all" label="全选" value="all" ></el-option>
              <el-option v-for="item in 12" :key="item" :label="item" :value="item"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="9">
          <el-form-item label="公司：" required>
            <el-select v-model="company" placeholder="请选择公司" @change="getTeamList">
              <el-option v-for="item in companyList" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="13">
          <el-form-item label="团队：" required>
            <el-select v-model="team" placeholder="请选择团队" @change="getEmployeeList">
              <el-option v-for="item in teamList" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="9">
          <el-form-item label="员工：" required>
            <el-select v-model="employee_ids" placeholder="请选择员工" multiple>
              <el-option v-for="item in employeeList" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <div style="margin-left: 10px;font-size: 15px;"><b>KPI复制</b></div>
      <el-row style="margin-top: 5px;">
        <el-col :span="6">
          <el-form-item label="年度：" label-width="100px">
            <el-select v-model="copyYear" @change="getCopyEmployeeList">
              <el-option v-for="year in yearList" :key="year.value" :label="year.label" :value="year.value"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="月份：" label-width="80px">
            <el-select v-model="copyMonth" @change="getCopyEmployeeList">
              <el-option v-for="item in 12" :key="item" :label="item" :value="item"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="7">
          <el-form-item label="复制员工：" label-width="100px">
            <el-select v-model="copyEmployeeId" >
              <el-option v-for="item in copyEmployeeList" :key="item.employee_id" :label="item.employee_name" :value="item.employee_id"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="5">
            <el-button style="margin-left: 15px" type="primary" @click="setEmployeeKpiValue">复制KPI</el-button>
        </el-col>
      </el-row>

    </el-form>
    <div style="margin-left: 10px;margin-bottom: 10px">员工月度KPI设定：&nbsp;&nbsp;&nbsp;&nbsp;
      <span v-if="!year" style="color: #fc0202">(请选择年度后获取KPI数据)</span>
    </div>
    <div style="display: flex;margin-left: 10px;margin-right: 10px;background-color: #cccccc;text-align: center;line-height: 30px">
      <div style="width: 80px;">序号</div>
      <div style="flex: 1">KPI名称</div>
      <div style="width: 150px">KPI数值(套/个)</div>
    </div>
    <div style="min-height: 200px;margin-top: 10px;margin-bottom: 10px">
      <div v-for="(item,index) in employeeKpiList"
           style="display: flex;margin: 10px 10px 0 10px;text-align: center;line-height: 30px">
        <div style="width: 80px;">{{index + 1}}</div>
        <div style="flex: 1">{{item.kpi_name}}</div>
        <div style="width: 150px">
          <el-input-number style="padding: 0 5px 0 5px;" v-model="item.kpi_value" min="0" :controls="false" ></el-input-number>
        </div>
      </div>
    </div>
    <div style="text-align: center;">
      <el-button type="primary" style="width: 100px" @click="addEmployeeKpi">提交</el-button>
      <el-button type="primary" style="width: 100px" @click="addEmployeeKpi('keep_on')">提交后继续</el-button>
    </div>



  </el-scrollbar>

</template>

<script>
export default {
  name: "AddEmployeeKpi",
  inject: ['$fn'],

  data(){
    return{
      company:'',
      team:'',
      copyYear:'',
      copyMonth:'',
      copyEmployeeId:'',
      copyEmployeeList:[],
      employee_ids:[],
      year:'',
      month:[],
      companyList:[],
      teamList:[],
      employeeList:[],
      yearList:[],
      employeeKpiList:[],
    }
  },
  async created() {
    await this.initData();
  },
  methods: {
    async initData(){
      await this.getCompanyList();
      await this.getYearList();
    },
    addEmployeeKpi(type){
      if(!this.year){
        this.$message.error("请选择年度");
        return;
      }
      if(this.month.length === 0){
        this.$message.error("请选择月份");
        return;
      }
      if(!this.company){
        this.$message.error("请选择公司");
        return;
      }
      if(!this.team){
        this.$message.error("请选择团队");
        return;
      }
      if(this.employee_ids.length === 0){
        this.$message.error("请选择员工");
        return;
      }
      if(!this.employeeKpiList || this.employeeKpiList.length === 0){
        this.$message.error("KPI项目数据为空");
        return;
      }
      let params = {year:this.year,
        month:this.month,
        company:this.company,
        team:this.team,
        employee_ids:this.employee_ids,
        employeeKpiList:this.employeeKpiList}
      this.$http('crmEmployeeService.addEmployeeKpi',params).then(() => {
        if(type !== 'keep_on'){
          this.$fn.closeWindow();
        }
        this.$fn.search();
        this.$message.success("提交成功");
      });
    },
    async getCompanyList(){
      this.companyList = await this.$http('crmTeamService.getCompanyList');
    },
    async getYearList(){
      this.yearList = await this.$http('sysDsService.getYears(5,2)')
    },
    //获取复制员工数据
    async getCopyEmployeeList(){
      if(!this.copyYear || !this.copyMonth){
        return;
      }
      let params = {year:this.copyYear,month:this.copyMonth}
      this.copyEmployeeList = await this.$http('crmEmployeeService.getCopyEmployeeList',params);
    },
    //加载复制员工的kpi Value值
    setEmployeeKpiValue(){
      if(!this.employeeKpiList){
        return;
      }
      for (let item of this.copyEmployeeList){
        if (item.employee_id === this.copyEmployeeId) {
          //复制员工的kpi值
          let employeeKpiObjList = item.employeeKpiList;
          //设置员工的kpiList   先循环需要设置员工的kpi项  再循坏复制员工的kpi项  最后设置kpi的值
          for (let kpi of this.employeeKpiList) {
            let kpiName = kpi.kpi_name;
            for (let kpiObj of employeeKpiObjList){
              let kpiObjName = kpiObj.kpi_name;
              if(kpiName === kpiObjName){
                kpi.kpi_value = kpiObj.kpi_value;
                break;
              }
            }
          }
        }
      }
    },
    //获取员工的KPI项目
    async getEmployeeKpiList() {
      if (!this.year) {
        this.$message.error("请选择年度后获取KPI数据");
      }
      let params = {year: this.year}
      this.employeeKpiList = await this.$http('crmEmployeeService.getEmployeeKpiList', params);
    },
    //根据公司选择团队数据
    async getTeamList(){
      let params = {company:this.company}
      this.teamList = await this.$http('crmTeamService.getTeamByCompany',params);
      if(this.team){
        this.team = "";
      }
      if(this.employee_ids){
        this.employee_ids = [];
      }
    },
    //根据团队获取员工
    async getEmployeeList(){
      let params = {team:this.team}
      this.employeeList = await this.$http('crmTeamService.getEmployeeByTeam',params);
      if(this.employee_ids){
        this.employee_ids = [];
      }
    },
  }
}
</script>

<style scoped>

</style>